import { amountCommaSeparateFunc, CommonConsole, compareGSTINState, GET_COMPANY_FROM_URL, loginUserName, roundFixed, roundToDecimalPlaces } from "../../../components/Common/CommonFunction";
import SERVER_HOST_PATH from "../../../helpers/_serverPath";
import { url } from "../../../routes";
import { invoice_discountCalculate_Func } from "../Invoice/invoiceCaculations";

export const postWithBasicAuth = async ({
    jsonBody,
    btnId = null,
    OrderID,
    APIName
}) => {
    // Get username and password for basic authentication
    const username = loginUserName();
    const password = localStorage.getItem(`${GET_COMPANY_FROM_URL()}_Password`);
    const authHeader = 'Basic ' + window.btoa(`${username}:${password}`);

    // Configure headers
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", authHeader);

    // Set up request options
    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: typeof jsonBody === "string" ? jsonBody : JSON.stringify(jsonBody), // Convert body to string if necessary
        redirect: "follow",
    };

    try {
        // Make the POST request
        const response = await fetch(`${SERVER_HOST_PATH}${APIName}`, requestOptions);
        let jsonData = {};
        try {
            jsonData = await response.json();
        } catch (error) {
            jsonData = {
                Message: response.ok ? "Invalid server response" : response.statusText || "Request failed",
            };
        }

        if (jsonData.Status === undefined) {
            jsonData.Status = jsonData.Success;
        }
        if (jsonData.StatusCode === undefined) {
            jsonData.StatusCode = jsonData.status_code ?? response.status;
        }
        if (jsonData.Status === undefined) {
            jsonData.Status = response.ok;
        }
        if (jsonData.Message === undefined) {
            jsonData.Message = response.ok ? "Success" : response.statusText || "Request failed";
        }

        // Add additional processing for specific cases
        if (btnId === "print") {
            jsonData["saveAndDownloadPdfMode"] = true;
        }
        if (jsonData.TransactionID && Array.isArray(jsonData.TransactionID)) {
            jsonData["TransactionID"] = jsonData.TransactionID[0];
            jsonData["OrderID"] = OrderID
        }

        return jsonData;
    } catch (error) {
        console.error("Error in POST request:", error);
        return {
            Status: false,
            StatusCode: 0,
            Message: error?.message || "Network request failed",
        };
    }
};

export function orderQtyOnChange(event, index1, IsComparGstIn) {

    let inputValue = event.target.value;

    event.target.value = inputValue;
    index1.Quantity = inputValue
    index1.StockDetails.forEach(index2 => {
        index2.Qty = inputValue
        Franchies_invoice_Calculate_Func(index2, index1, IsComparGstIn);
    })
}

export function orderQtyUnit_SelectOnchange(event, index1, IsComparGstIn) {

    index1.default_UnitDropvalue = event;
    index1.ConversionUnit = event.ConversionUnit;

    index1.StockDetails.forEach(index2 => {

        const _hasRate = ((event.BaseUnitQuantity / event.BaseUnitQuantityNoUnit) * index1.Rate);
        index2.Rate = roundToDecimalPlaces(_hasRate, 2);//max 2 decimal 
        document.getElementById(`stockItemRate-${index1.id}`).innerText = amountCommaSeparateFunc(index2.Rate);
        Franchies_invoice_Calculate_Func(index2, index1, IsComparGstIn);
    })
};


export function RoundCalculationFunc(data) {

    const NetAmount = data.reduce((sum, item) => sum + item.Amount, 0); // Ensure 2 decimal places
    const DiscountTotalAmount = data.reduce((sum, item) => sum + parseFloat(item.DiscountAmount || 0), 0); // Convert string to number and sum
    const totalAmount = (NetAmount + DiscountTotalAmount); // Subtract and ensure 2 decimal places
    const RoundedAmount = Math.round(NetAmount); // Nearest integer
    const RoundOffAmount = (NetAmount - RoundedAmount); // Difference rounded to 2 decimal places

    return {
        "DiscountAmount": Number(Number(DiscountTotalAmount).toFixed(2)),
        "TotalAmount": Number(Number(totalAmount).toFixed(2)),
        "NetAmount": Number(Number(NetAmount).toFixed(2)),
        "RoundedAmount": Number(Number(RoundedAmount).toFixed(2)),
        "RoundOffAmount": Number(Number(RoundOffAmount).toFixed(2)),
    }
}

export const DiscountCaculationForFranchies = (index1, IsComparGstIn) => {

    let totalAmount = 0;

    index1.StockDetails.forEach(index2 => {
        if (Number(index2.Qty) > 0) {
            const calculate = Franchies_invoice_Calculate_Func(index2, index1, IsComparGstIn);
            totalAmount += Number(calculate.ItemTotalAmount);
        }
    });

    index1.ItemTotalAmount = roundToDecimalPlaces(totalAmount, 2); //max 2 decimal

    try {
        document.getElementById(`item-TotalAmount-${index1.id}`).innerText = amountCommaSeparateFunc(index1.ItemTotalAmount);
    } catch (e) { CommonConsole('inner-Stock-Caculation', e) };
}

export function Franchies_invoice_Calculate_Func(row, index1, IsComparGstIn,) {

    const discountBasedOnRate = true
    const qty = (Number(row.Qty)) || 0;
    const initialRate = Number(row.MRP) || 0;
    let rate = Number(row.MRP) || 0;
    const gstPercentage = Number(index1.GSTPercentage) || 0;
    const discountValue = Number(index1.Discount) || 0;
    const discountType = Number(index1.DiscountType) || 2;

    let discountAmount = 0;

    // Calculate the discount before Taxable calculation
    if (discountValue > 0 && discountBasedOnRate) {
        if (discountType === 1) {//'Rs'
            rate -= discountValue;
            discountAmount = parseFloat((discountValue * qty).toFixed(2));
        } else {
            discountAmount = parseFloat(((rate * discountValue / 100) * qty).toFixed(2));
            rate = parseFloat((rate - (rate * discountValue / 100)).toFixed(2));
        }
    }

    const grossAmount = qty * rate;

    // Handle case where quantity is zero
    let taxableAmount = 0;

    if (qty !== 0) {
        taxableAmount = parseFloat((grossAmount * 100 / (100 + gstPercentage)).toFixed(2));
        row.Rate = parseFloat((Number(row.MRP) * 100 / (100 + Number(row.GSTPercentage))).toFixed(2))
        index1.UnitDetails = index1.UnitDetails.map(unit => ({
            ...unit, Rate: parseFloat((Number(row.MRP) * 100 / (100 + Number(row.GSTPercentage))).toFixed(2)),
        }))
    }

    let cgst = parseFloat((taxableAmount * (gstPercentage / 2) / 100).toFixed(2));
    let sgst = cgst;
    let igst = 0; // Assuming local billing, hence IGST is 0
    let gstAmount = cgst + sgst;

    let CGST_Percentage = gstPercentage / 2;
    let SGST_Percentage = gstPercentage / 2;
    let IGST_Percentage = 0





    // Final amount after applying GST
    let itemFinalAmount = taxableAmount + gstAmount;

    // Adjust Taxable Amount and Item Final Amount to handle 1 paisa differences
    if (discountValue === 0) {
        taxableAmount = (qty * rate) - gstAmount;
        itemFinalAmount = taxableAmount + gstAmount;
    } else {
        if (discountType === 1) {//'Rs'
            taxableAmount = (qty * rate) - gstAmount;
            itemFinalAmount = taxableAmount + gstAmount;
        } else {
            taxableAmount = (qty * initialRate) - discountAmount - gstAmount;
            itemFinalAmount = taxableAmount + gstAmount;
        }
    }

    if (IsComparGstIn) {  //compare Supplier and Customer are Same State by GSTIn Number

        let isSameSate = compareGSTINState(IsComparGstIn.GSTIn_1, IsComparGstIn.GSTIn_2, IsComparGstIn?.IsSEZ);
        if (isSameSate) {// iF isSameSate = true ===not same GSTIn

            cgst = 0;
            sgst = 0;
            igst = Number(gstAmount.toFixed(2))
            IGST_Percentage = gstPercentage;
            SGST_Percentage = 0;
            CGST_Percentage = 0;
        }
    }

    index1.ItemTotalAmount = itemFinalAmount;

    return {
        // discountBaseAmt: Number(discountBaseAmt.toFixed(2)),
        disCountAmt: discountAmount.toFixed(2),
        ItemTotalAmount: Number(roundFixed(itemFinalAmount, 2)),
        taxableAmount: Number(roundFixed(taxableAmount, 2)),
        CGST_Amount: Number(roundFixed(cgst, 2)),
        SGST_Amount: Number(roundFixed(sgst, 2)),
        IGST_Amount: Number(roundFixed(igst, 2)),
        GST_Amount: (roundFixed(gstAmount, 2)),
        CGST_Percentage: Number(roundFixed(CGST_Percentage, 2)),
        SGST_Percentage: Number(roundFixed(SGST_Percentage)),
        IGST_Percentage: Number(roundFixed(IGST_Percentage, 2)),

    };
}

export const calculateCssBulkItem = (item, gstObj) => {

    const conversion = Number(item.default_UnitDropvalue?.ConversionUnit || 1);
    const qtyInBase = Number(item.Quantity || 0) * conversion;
    // const _hasRate = ((defaultunit.BaseUnitQuantity / defaultunit.BaseUnitQuantityNoUnit) * index2.initialRate);
    // const _hasActualQuantity = (index2.BaseUnitQuantity / defaultunit.BaseUnitQuantity);
    const row = {
        Rate: Number(item.Rate) || 0,
        Qty: qtyInBase,
        GST: Number(item.GSTPercentage) || 0
    };

    // Use the Invoice calculator so CSS Bulk produces the exact same discount,
    // tax, and total values as Invoice.
    const result = invoice_discountCalculate_Func(row, item, gstObj,url.CSS_BULK_INVOICE);

    item.BasicAmount = result.discountBaseAmt;
    item.GSTAmount = result.roundedGstAmount;
    item.Amount = result.roundedTotalAmount;
    item.ItemTotalAmount = result.roundedTotalAmount;

    item.DiscountAmount = result.disCountAmt;
    item.CGST = result.CGST_Amount;
    item.SGST = result.SGST_Amount;
    item.IGST = result.IGST_Amount;

    return result;
};
